/**
 * zero & year library version 1.0.0
 */

const get = async (crud, queryId, params) => {
    let source = {};
    source.crud = crud||'';
    source.queryId = queryId||'';
    source.params = params||'';
    let res = await fetch(`/commonQuerys`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(source)
    });
    let data = await res.json();
    return data;
}

/**
 * select
 * @param {*} queryId, params, callback
 */
export function select(queryId, params, callback) {
    return get('select', queryId, params).then(data => callback(data));
}

/**
 * create
 * @param {*} queryId, params, callback
 */
export function create(queryId, params, callback) {
    return get('create', queryId, params).then(data => callback(data));
}

/**
 * modify
 * @param {*} queryId, params, callback
 */
export function modify(queryId, params, callback) {
    return get('modify', queryId, params).then(data => callback(data));
}

/**
 * destroy
 * @param {*} queryId, params, callback
 */
export function destroy(queryId, params, callback) {
    return get('destroy', queryId, params).then(data => callback(data));
}

/**
 * login session
 */
export function login(queryId, params, callback) {
    return get('login', queryId, params).then(data => callback(data));
}

/**
 * format date string
 */
export function getFormatDate(date){
    var year = date.getFullYear();
    var month = (1 + date.getMonth());
    month = month > 10 ? month : '0' + month; // 10이 넘지 않으면 앞에 0을 붙인다
    var day = date.getDate();
    day = day > 10 ? day : '0' + day; // 10이 넘지 않으면 앞에 0을 붙인다
    var hours = date.getHours();
    hours = hours > 10 ? hours : '0' + hours; // 10이 넘지 않으면 앞에 0을 붙인다
    var minutes = date.getMinutes();
    minutes =  minutes > 10 ? minutes : '0' + minutes; // 10이 넘지 않으면 앞에 0을 붙인다
    var seconds = date.getSeconds();
    seconds = seconds > 10 ? seconds : '0' + seconds; // 10이 넘지 않으면 앞에 0을 붙인다
    return `${year}${month}${day}${hours}${minutes}${seconds}`
}

export function navFuc() {
    (function () {
    /**
     * Scrolls to an element with header offset
     */
    const scrollto = (el) => {
        let header = select('#header')
        let offset = header.offsetHeight
    
        if (!header.classList.contains('header-scrolled')) {
            offset -= 16
        }
    
        let elementPos = select(el).offsetTop
        window.scrollTo({
            top: elementPos - offset,
            behavior: 'smooth'
        })
        }
        /**
         * Easy on scroll event listener 
         */
        const onscroll = (el, listener) => {
        el.addEventListener('scroll', listener)
        }
        /**
         * Easy selector helper function
         */
        const select = (el, all = false) => {
        el = el.trim()
        if (all) {
            return [...document.querySelectorAll(el)]
        } else {
            return document.querySelector(el)
        }
        }
        /**
         * Easy event listener function
         */
        const on = (type, el, listener, all = false) => {
        let selectEl = select(el, all)
        if (selectEl) {
            if (all) {
            selectEl.forEach(e => e.addEventListener(type, listener))
            } else {
            selectEl.addEventListener(type, listener)
            }
        }
        }
        /**
         * Navbar links active state on scroll
         */
        let navbarlinks = select('#navbar .scrollto', true)
        const navbarlinksActive = () => {
        let position = window.scrollY + 200
        navbarlinks.forEach(navbarlink => {
            if (!navbarlink.hash) return
            let section = select(navbarlink.hash)
            if (!section) return
            if (position >= section.offsetTop && position <= (section.offsetTop + section.offsetHeight)) {
            navbarlink.classList.add('active')
            } else {
            navbarlink.classList.remove('active')
            }
        })
        }
        window.addEventListener('load', navbarlinksActive)
        onscroll(document, navbarlinksActive)
    
        /**
         * Mobile nav toggle
         */
        on('click', '.mobile-nav-toggle', function(e) {
        select('#navbar').classList.toggle('navbar-mobile')
        this.classList.toggle('bi-list')
        this.classList.toggle('bi-x')
        })
    
        /**
         * Mobile nav dropdowns activate
         */
        on('click', '.navbar .dropdown > a', function(e) {
        if (select('#navbar').classList.contains('navbar-mobile')) {
            e.preventDefault()
            this.nextElementSibling.classList.toggle('dropdown-active')
        }
        }, true)
    
        /**
         * Scrool with ofset on links with a class name .scrollto
         */
        on('click', '.scrollto', function(e) {
        if (select(this.hash)) {
            e.preventDefault()
    
            let navbar = select('#navbar')
            if (navbar.classList.contains('navbar-mobile')) {
            navbar.classList.remove('navbar-mobile')
            let navbarToggle = select('.mobile-nav-toggle')
            navbarToggle.classList.toggle('bi-list')
            navbarToggle.classList.toggle('bi-x')
            }
            scrollto(this.hash)
        }
        }, true)
    })();
    setTimeout(()=>{
        (function () {
            /**
             * Scrolls to an element with header offset
             */
            const scrollto = (el) => {
                let header = select('#header')
                let offset = header.offsetHeight
            
                if (!header.classList.contains('header-scrolled')) {
                    offset -= 16
                }
            
                let elementPos = select(el).offsetTop
                window.scrollTo({
                    top: elementPos - offset,
                    behavior: 'smooth'
                })
                }
                /**
                 * Easy on scroll event listener 
                 */
                const onscroll = (el, listener) => {
                el.addEventListener('scroll', listener)
                }
                /**
                 * Easy selector helper function
                 */
                const select = (el, all = false) => {
                el = el.trim()
                if (all) {
                    return [...document.querySelectorAll(el)]
                } else {
                    return document.querySelector(el)
                }
                }
                /**
                 * Easy event listener function
                 */
                const on = (type, el, listener, all = false) => {
                let selectEl = select(el, all)
                if (selectEl) {
                    if (all) {
                    selectEl.forEach(e => e.addEventListener(type, listener))
                    } else {
                    selectEl.addEventListener(type, listener)
                    }
                }
                }
                /**
                 * Navbar links active state on scroll
                 */
                let navbarlinks = select('#navbar .scrollto', true)
                const navbarlinksActive = () => {
                let position = window.scrollY + 200
                navbarlinks.forEach(navbarlink => {
                    if (!navbarlink.hash) return
                    let section = select(navbarlink.hash)
                    if (!section) return
                    if (position >= section.offsetTop && position <= (section.offsetTop + section.offsetHeight)) {
                    navbarlink.classList.add('active')
                    } else {
                    navbarlink.classList.remove('active')
                    }
                })
                }
                window.addEventListener('load', navbarlinksActive)
                onscroll(document, navbarlinksActive)
            
                /**
                 * Mobile nav toggle
                 */
                on('click', '.mobile-nav-toggle', function(e) {
                select('#navbar').classList.toggle('navbar-mobile')
                this.classList.toggle('bi-list')
                this.classList.toggle('bi-x')
                })
            
                /**
                 * Mobile nav dropdowns activate
                 */
                on('click', '.navbar .dropdown > a', function(e) {
                if (select('#navbar').classList.contains('navbar-mobile')) {
                    e.preventDefault()
                    this.nextElementSibling.classList.toggle('dropdown-active')
                }
                }, true)
            
                /**
                 * Scrool with ofset on links with a class name .scrollto
                 */
                on('click', '.scrollto', function(e) {
                if (select(this.hash)) {
                    e.preventDefault()
            
                    let navbar = select('#navbar')
                    if (navbar.classList.contains('navbar-mobile')) {
                    navbar.classList.remove('navbar-mobile')
                    let navbarToggle = select('.mobile-nav-toggle')
                    navbarToggle.classList.toggle('bi-list')
                    navbarToggle.classList.toggle('bi-x')
                    }
                    scrollto(this.hash)
                }
                }, true)
            })();       
    }, 500);
}